import React from 'react'
import Awards from './Awards/Awards'
import Featured from './Featured/Featured'
import Hero from './Hero/Hero'
import Recent from './Recent/Recent'
import Location from './Location/Location'
import Team from './Team/Team'
import Price from './Price/Price'

const Home = () => {
  return (
    <div>
      <Hero/>
      <Featured/>
      <Recent/>
      <Awards/>
      <Location/>
      <Team/>
      <Price/>
    </div>
  )
}

export default Home
